import gsap from 'gsap'
import { EventEmitter } from 'events'
import SplitType from 'split-type'
// import Cookie from 'Scripts/utils/Cookie'

export default class Preloader extends EventEmitter {
  constructor({ selector, counter, logo, intro }) {
    super()
    //
    this.selector = selector instanceof HTMLElement ? selector : document.querySelector(selector)
    this.counter = counter instanceof HTMLElement ? counter : document.querySelector(counter)
    this.logo = logo instanceof HTMLElement ? logo : document.querySelector(logo)
    this.intro = intro instanceof HTMLElement ? intro : document.querySelector(intro)

    //Intro          
    if (this.intro && document.location.pathname != '/ar/') {
      this.text = new SplitType(this.intro, { types: 'words, chars' })
    }
    this.text && this.animateTextOut()

    //
    this.length = 0
    this.imgArray = document.querySelectorAll("img")
    this.videoArray = document.querySelectorAll("video")


    //Methodes    
    if (this.selector) {
      this.animateIn()
      // this.imgArray.length ? this.createLoader() : this.onLoaded()
    }

  }

  async animateIn() {
    await this.animateLogo()
    await this.animateTextIn()
    setTimeout(() => {
      this.onLoaded()
    }, 1000);

  }

  animateLogo() {
    return new Promise(resolve => {
      gsap.to(this.logo, {
        scale: 1,
        autoAlpha: 1,
        duration: 1,
        ease: 'sine.inOut',
        onComplete: resolve
      })
    })
  }

  animateTextIn() {
    return new Promise(resolve => {

      if (this.text) {
        gsap.set(this.intro, { autoAlpha: 1 })
        gsap.to(this.text.chars, {
          autoAlpha: 1,
          y: '0%',
          stagger: 0.02,
          ease: 'sine.inOut',
          onComplete: resolve,
        })
      } else {
        gsap.to(this.intro, {
          autoAlpha: 1,
          y: '0%',
          ease: 'sine.inOut',
          onComplete: resolve,
        })
      }
    })
  }

  animateTextOut() {

    gsap.set(this.intro, { autoAlpha: 0 })
    gsap.set(this.text.chars, {
      autoAlpha: 0,
      y: '100%'
    })

  }


  createLoader() {

    this.videoArray.forEach(video => {
      // console.log(img.src)
      // const video = document.createElement('video')      
      // video.src = vid.src
      // video.autoplay = true
      video.addEventListener("canplaythrough", () => console.log('video loaded'), false)

    })

    this.imgArray.forEach(img => {
      // console.log(img.src)
      const media = new window.Image()
      media.src = img.src
      media.onload = () => this.onAssetLoaded()
    })


  }

  onAssetLoaded() {
    this.length += 1


    const percent = this.length / this.imgArray.length
    // console.log( this.length,this.imgArray.length,Math.round(percent * 100))

    this.counter.innerHTML = `${Math.round(percent * 100)}%`
    if (percent === 1) {
      this.onLoaded()
    }
  }

  // onLoaded() {
  //   this.tl = gsap.timeline({
  //     delay: 1
  //   })

  //   this.tl.to([this.logo, this.counter], {
  //     autoAlpha: 0,
  //     duration: 1,
  //     ease: 'Power2.easeOut',
  //     stagger: 0.2
  //   })

  //   this.tl.to(this.selector, {
  //     autoAlpha: 0,
  //     duration: 1,
  //     // y :'100%',
  //     ease: 'Power2.easeOut'
  //   })

  //   this.tl.call(() => {
  //     this.emit('completed')
  //     document.querySelector('html').classList.add('isReady')
  //     this.destroy()
  //   })

  // }

  onLoaded() {

    document.querySelector('html').classList.add('isReady')
    this.emit('completed')

  }


  destroy() {
    this.selector.parentNode.removeChild(this.selector)
  }

}

